export function isReorderArchetype(brandView) {
    var _brandView_brand_retailer_info;
    return !!((_brandView_brand_retailer_info = brandView.brand_retailer_info) === null || _brandView_brand_retailer_info === void 0 ? void 0 : _brandView_brand_retailer_info.has_prior_orders);
}
